import React from "react";

import { AnimatorConflict } from "./AnimatorConflict";

const AnimatorConflicts = ({ conflicts }: { conflicts: AnimatorConflict[] }) => {
  if (!conflicts || conflicts.length === 0) return null;

  return (
    <div className="text-start">
      {conflicts.map((conflict) => (
        <div key={conflict.animator_id} className="mb-3">
          <strong>{conflict.animator_name}</strong>

          <ul className="mt-2">
            {conflict.conflicting_meetings.map((meeting) => (
              <li key={`conflict-${conflict.animator_id}-${meeting.id}`}>
                <a href={`/meeting/${meeting.id}`} target="_blank" rel="noreferrer">
                  {meeting.name}
                </a>{" "}
                (
                {new Date(meeting.dt_start).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}{" "}
                -{" "}
                {new Date(meeting.dt_end).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
                )
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default AnimatorConflicts;
